import { useAppSelector } from "../../store/hooks";
import HeatmapReportScreen from "../reports/heatMapScreen";

export default function SharedHeatmapScreen() {
  const session = useAppSelector(state => state.session);
  return (<div>
    {session.shared?.project ? <HeatmapReportScreen projectId={session.shared.projectId} project={session.shared.project} /> : <p>You must have a project shared.</p>}
  </div>);
}
